import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14e42ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option" }
const _hoisted_2 = { class: "option__choice" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 선택필수 "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 0,
  class: "badge-red"
}
const _hoisted_6 = ["data-url"]
const _hoisted_7 = ["data-url"]
const _hoisted_8 = {
  key: 0,
  class: "options"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "badge-red"
}
const _hoisted_12 = { class: "option__selected" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "최종 선택 내용", -1 /* HOISTED */))
const _hoisted_14 = { class: "option__selected__info" }
const _hoisted_15 = { class: "info__price" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price__type" }, "수강권", -1 /* HOISTED */))
const _hoisted_17 = { class: "price__detail" }
const _hoisted_18 = { class: "detail__name" }
const _hoisted_19 = { class: "detail__price" }
const _hoisted_20 = { class: "discountPer" }
const _hoisted_21 = { class: "price__original" }
const _hoisted_22 = { class: "info__price" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price__type" }, "할인가", -1 /* HOISTED */))
const _hoisted_24 = { class: "price__detail" }
const _hoisted_25 = { class: "detail__name" }
const _hoisted_26 = { class: "detail__price detail__price--discounted" }
const _hoisted_27 = { class: "info__list" }
const _hoisted_28 = { class: "info__comment" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["select__box", { selected: $props.choicedOptionData?.title }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleCollapse && $options.toggleCollapse(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString($options.parserTitle($props.choicedOptionData?.title, $data.choiceIndex)), 1 /* TEXT */),
          ($data.choiceRecommend)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "추천"))
            : _createCommentVNode("v-if", true)
        ]),
        (!$data.isOpenCollapse)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 0,
              "data-url": $data.imgUrls.ic_arrow_down,
              class: "icon"
            }, null, 8 /* PROPS */, _hoisted_6)), [
              [_directive_img_lazy_loading]
            ])
          : _createCommentVNode("v-if", true),
        ($data.isOpenCollapse)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 1,
              "data-url": $data.imgUrls.ic_arrow_up,
              class: "icon"
            }, null, 8 /* PROPS */, _hoisted_7)), [
              [_directive_img_lazy_loading]
            ])
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      ($data.isOpenCollapse)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.Plans, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                onClick: ($event: any) => ($options.sendChoicedOptionId(option.cp_idx, index, option.isRecommend)),
                class: _normalizeClass({ selected: $data.copyChoicedOptionIdx === option.cp_idx }),
                key: option.cp_idx
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString($options.replacedTitle(option.title)) + " ", 1 /* TEXT */),
                  (option.isRecommend)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "추천"))
                    : _createCommentVNode("v-if", true)
                ])
              ], 10 /* CLASS, PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString($props.choicedOptionData?.title), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString($props.choicedOptionData?.discount) + "%", 1 /* TEXT */),
              _createTextVNode(" " + _toDisplayString(_ctx.priceComma($props.choicedOptionData?.money)) + "원 ", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.priceComma($props.choicedOptionData?.origin_money)), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString($data.currentOptionInstallment) + "개월 할부 시", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_26, " 월 " + _toDisplayString(_ctx.priceComma($props.choicedOptionData?.moneyPerMonth)) + "원 ", 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("ul", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentOptionServes, (optionServe, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(optionServe), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createTextVNode(_toDisplayString($data.thisWeekStart) + "~" + _toDisplayString($data.thisWeekEnd) + " 구매자는 ", 1 /* TEXT */),
          _hoisted_29,
          _createTextVNode(" " + _toDisplayString($data.nextWeekStart) + "부터 수업 시작이 가능합니다. ", 1 /* TEXT */),
          _createElementVNode("p", null, _toDisplayString($data.nextWeekStart) + "이전에 수강권 '지금 바로 시작하기'를 누르지 않도록 유의해주세요.", 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}